import React, { useEffect, useState } from "react";
import HeaderSection from "./HeaderSection";
import Pagination from "../reusable_components/Pagination";
import { findOrders } from "../api/partstechApi";
import { toast } from "react-toastify";
import PartstechOrderItem from "./PartstechOrderItem";

const PartstechOrders = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [reloadTable, setReloadTable] = useState(false)
  const [activeTab, setActiveTab] = useState("part");

  const fetchFiles = async (page = 1, activeTab) => {
    setLoading(true);
    setError(null);

    try {
      const response = await findOrders(page, activeTab);
      setFiles(response.data?.data || []);
      setTotalPages(response.data?.pagination?.totalPages || 1);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles(currentPage, activeTab);
    setFiles((prevFiles) =>
      prevFiles.map((file) => ({ ...file, selected: false }))
    );
  }, [currentPage, reloadTable, activeTab]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <div>Loading data...</div>;
  if (error) return toast.error("Could not get orders", { autoClose: 3000 });

  return (
    <div>
      <div className="flex justify-between items-center mb-3 text-center">
        <HeaderSection title={"Orders"} />
      </div>
      <div className="flex border-b">
        {[
          { key: "part", label: "Part" },
          { key: "tire", label: "Tire" },
        ].map((tab) => (
          <button
            key={tab.key}
            className={`flex-1 p-2 ${activeTab === tab.key ? "border-b-2 border-blue-500 font-bold bg-slate-200" : ""
              }`}
            onClick={() => handleTabChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="overflow-hidden">
        {files.map((row, rowIndex) => (
          <PartstechOrderItem key={rowIndex} data={row} setReloadTable={setReloadTable} />
        ))}
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default PartstechOrders;
